var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { isNil } from '../../value/isNil';
import { removeAt } from '../removeAt';
import { typeOf } from '../../type/typeOf';
/**
 * Immutably removes an item or items based on the predicate
 *
 * @since v2.36.0
 * @category Array
 * @template {T} The type of the array
 * @param {T[]} array The array of items
 * @param {(item: T) => boolean} predicate Function that returns true if the item should be removed or false if it should not
 * @param {boolean} [all=true] Whether or not all items matching the predicate should be removed or just the first match
 * @returns {T[]}
 * @example
 * const array = [7, 25, 21];
 *
 * removeIf(array, item => item > 20)
 * //=> [7]
 *
 * removeIf(array, item => item > 20, false)
 * //=> [7, 21]
 * @docgen_example
 * const array = [7, 25, 21];
 *
 * removeIf(array, item => item > 20);
 */
export var removeIf = function (array, predicate, all) {
    if (all === void 0) { all = true; }
    if (typeOf(array) !== 'array' || isNil(predicate))
        return array;
    var indexes = [];
    if (all) {
        for (var index = array.length - 1; index >= 0; index--) {
            if (predicate(array[index])) {
                array = removeAt(array, index);
            }
        }
    }
    else {
        indexes = [array.findIndex(predicate)];
    }
    return removeAt.apply(void 0, __spreadArray([array], indexes, false));
};
